var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":"https://file.haoxinqing.cn/data/hxq/static/project/common/imgs/hxqhosp/关于公司.jpg","alt":""}}),_c('img',{attrs:{"src":"https://file.haoxinqing.cn/data/hxq/static/project/common/imgs/hxqhosp/公司资质2.jpg","alt":""}})])
}]

export { render, staticRenderFns }